import {
  generateGetAction,
  generatePostAction,
  generateAction,
  generatePutAction,
  generateDeleteAction,
} from '@services/ActionDispatcher';

import {
  getLaboratoryOrdersAction,
  getLaboratoryLabOrderMessageThreadAction,
  getLabOrdersAction,
  getLabOrderMessagesAction,
  markLabOrderConversationReadAction,
  markLabOrderConversationInListReadAction,
  markLabOrderConversationInListUnreadAction,
  getLabOrderMessageThreadAction,
  sendLabOrderMessageAction,
  updateLaboratoryLabOrderStatusAction,
  getLabOrderMessageAttachmentsAction,
  downloadLabOrderMessageAttachmentAction,
  deleteLabOrderMessageAttachmentAction,
  deleteLabOrderAttachmentAction,

  clearLabOrderDataAction,
  displayLabOrderMessageAction,
  updateLabOrderMessageAction,
  deleteLabOrderMessageAction,
  deleteLabOrderReceiverMessageAction,
  updateUnreadLabOrderMessageCountAction,
  updateLabOrderListAction,
  updateLabOrderMessageStatusAction,
  updateLabOrderFollowUpStatusAction,
  updateLaboratoryFollowUpStatusAction,
  getHomeOngoingLabOrdersAction,
} from './LabOrderActionConfig';

const clearLabOrderDataDispatch = () => generateAction(
  clearLabOrderDataAction,
);

const displayLabOrderMessageDispatch = (
  data: any) => generateAction(displayLabOrderMessageAction, data);
const updateLabOrderMessageDispatch = (
  data: any) => generateAction(updateLabOrderMessageAction, data);
const deleteLabOrderMessageDispatch = (
  data: any) => generateAction(deleteLabOrderMessageAction, data);
const deleteLabOrderReceiverMessageDispatch = (
  data: any) => generateAction(deleteLabOrderReceiverMessageAction, data);
const updateUnreadLabOrderMessageCountDispatch = (
  data: any) => generateAction(updateUnreadLabOrderMessageCountAction, data);
const updateLabOrderListDispatch = (data: any) => generateAction(updateLabOrderListAction, data);
const updateLabOrderMessageStatusDispatch = (
  data: any) => generateAction(updateLabOrderMessageStatusAction, data);

const getLaboratoryOrdersRequest = (params: any) => generateGetAction(
  // action name
  getLaboratoryOrdersAction,
  // url
  'laboratory/orders',
  {
    queryParams: params,
  },
  params,
);

/** Home's "Ongoing orders" table keeps its rows to itself (see getHomeOngoingReferralsRequest). */
const getHomeOngoingLabOrdersRequest = (params: any) => generateGetAction(
  // action name
  getHomeOngoingLabOrdersAction,
  // url
  'laboratory/orders',
  {
    queryParams: params,
  },
  params,
);

const getLaboratoryLabOrderMessageThreadRequest = (id: any) => generateGetAction(
  // action name
  getLaboratoryLabOrderMessageThreadAction,
  // url
  `laboratory/orders/${id}/messages/thread`,
);

const updateLaboratoryLabOrderStatusRequest = (data: any, id: any) => generatePutAction(
  // action name
  updateLaboratoryLabOrderStatusAction,
  // url
  `laboratory/orders/${id}/status`,
  data,
);

const getLabOrdersRequest = (params: any) => generateGetAction(
  // action name
  getLabOrdersAction,
  // url
  'lab-orders',
  {
    queryParams: params,
  },
  params,
);

const getLabOrderMessagesRequest = (id: any, params: any) => generateGetAction(
  // action name
  getLabOrderMessagesAction,
  // url
  `lab-orders/${id}/messages`,
  {
    queryParams: params,
  },
  { id },
);

const markLabOrderConversationReadRequest = (id: any, userId: any) => generatePostAction(
  // action name
  markLabOrderConversationReadAction,
  // url
  `lab-orders/${id}/messages/mark-as-read`,
  { userId },
);

// this is used to mark lab orders as read via the action button
const markLabOrderConversationInListReadRequest = (data: any) => generatePostAction(
  // action name
  markLabOrderConversationInListReadAction,
  // url
  `lab-orders/${data?.lab_order_id}/messages/mark-as-read`,
  { data },
);

// this is used to mark lab orders as unread via the action button
const markLabOrderConversationInListUnreadRequest = (data: any) => generatePostAction(
  // action name
  markLabOrderConversationInListUnreadAction,
  // url
  `lab-orders/${data?.lab_order_id}/messages/mark-as-unread`,
  { data },
);

const getLabOrderMessageThreadRequest = (id: any) => generateGetAction(
  // action name
  getLabOrderMessageThreadAction,
  // url
  `lab-orders/${id}/messages/thread`,
);

const sendLabOrderMessageRequest = (id: any, data: any) => generatePostAction(
  // action name
  sendLabOrderMessageAction,
  // url
  `lab-orders/${id}/messages/send`,
  data,
);

const getLabOrderMessageAttachmentsRequest = (id: any, params: any) => generateGetAction(
  // action name
  getLabOrderMessageAttachmentsAction,
  // url
  `lab-orders/${id}/messages/attachments`,
  {
    queryParams: params,
  },
  params,
);

const downloadLabOrderMessageAttachmentRequest = (data: any) => generatePostAction(
  // action name
  downloadLabOrderMessageAttachmentAction,
  // url
  `lab-orders/${data?.id}/messages/attachments/${data?.attachment_id}/download`,
  data,
);

const deleteLabOrderMessageAttachmentRequest = (data: any) => generateDeleteAction(
  // action name
  deleteLabOrderMessageAttachmentAction,
  // url
  `lab-orders/${data?.id}/messages/${data?.conversation_id}/attachment/${data?.attachment_id}`,
  { data },
);

const deleteLabOrderAttachmentRequest = (data: any) => generateDeleteAction(
  // action name
  deleteLabOrderAttachmentAction,
  // url
  `lab-orders/${data?.referral_id}/attachment/${data?.id}`,
  { data },
);

const updateLabOrderFollowUpStatusRequest = (id: any, data: any) => generatePutAction(
  // action name
  updateLabOrderFollowUpStatusAction,
  // url
  `lab-orders/${id}/follow-up`,
  data,
);

const updateLaboratoryFollowUpStatusRequest = (id: any, data: any) => generatePutAction(
  // action name
  updateLaboratoryFollowUpStatusAction,
  // url
  `laboratory/orders/${id}/follow-up`,
  data,
);

export {
  // normal dispatch
  clearLabOrderDataDispatch,
  displayLabOrderMessageDispatch,
  updateLabOrderMessageDispatch,
  deleteLabOrderMessageDispatch,
  deleteLabOrderReceiverMessageDispatch,
  updateUnreadLabOrderMessageCountDispatch,
  updateLabOrderListDispatch,
  updateLabOrderMessageStatusDispatch,

  // async (request) dispatch
  // eslint-disable-next-line import/prefer-default-export
  getLaboratoryOrdersRequest,
  getHomeOngoingLabOrdersRequest,
  getLaboratoryLabOrderMessageThreadRequest,
  getLabOrdersRequest,
  getLabOrderMessagesRequest,
  markLabOrderConversationReadRequest,
  markLabOrderConversationInListReadRequest,
  markLabOrderConversationInListUnreadRequest,
  getLabOrderMessageThreadRequest,
  sendLabOrderMessageRequest,
  updateLaboratoryLabOrderStatusRequest,
  getLabOrderMessageAttachmentsRequest,
  downloadLabOrderMessageAttachmentRequest,
  deleteLabOrderMessageAttachmentRequest,
  deleteLabOrderAttachmentRequest,
  updateLabOrderFollowUpStatusRequest,
  updateLaboratoryFollowUpStatusRequest,
};
